import React from 'react'
import { Input } from 'antd'
import FilterDateRangeV2 from '../../home/components/filters/FilterDateRangeV2'
import SelectFilterOptions from '../../shared/SelectFilterOptions'

const { Search } = Input

const STATUS = [
    {
        name: "Pending",
        value: 'pending'
    },
    {
        name: "Processing",
        value: 'processing'
    },
    {
        name: "Error",
        value: 'error'
    },
    {
        name: "Retry",
        value: 'retry'
    },
    {
        name: "Done",
        value: 'done'
    },
]

const OddBatchFilter = (props) => {
    const { startCreate, onChangeName, onChangeDate, onChangeStatus, onChageNameGraft } = props

    let _timeOut = null

    const _handleChangeName = e => {
        const { value } = e.target

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            onChangeName(value)
        }, 500)
    }

    const _handleChangeNameGraft = e => {
        const { value } = e.target

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            onChageNameGraft(value)
        }, 500)
    }

    const _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, startCreate)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        onChangeDate(field, cloneFilter)
    }

    return (
        <div className='OddBatchFilter'>
            <div className='row align-items-starts'>
                <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Tên lô lẻ</label>
                    <div className='SearchField'>
                        <Search
                            placeholder='Nhập tên lô bạn muốn tìm kiếm'
                            onChange={_handleChangeName}
                            allowClear={true}
                        />
                    </div>
                </div>
                <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Tên lô ghép</label>
                    <div className='SearchField'>
                        <Search
                            placeholder='Nhập tên lô bạn muốn tìm kiếm'
                            onChange={_handleChangeNameGraft}
                            allowClear={true}
                        />
                    </div>
                </div>
                <div className='col-12 col-xl-3 mb-3'>
                    <label className="font-weight-bold">Ngày tạo</label>
                    <FilterDateRangeV2
                        field='created'
                        onDatesChange={_handleChangeDate}
                        showTime={true}
                    />
                </div>
                <div className='col-12 col-xl-3 mb-3'>
                    <SelectFilterOptions
                        defaultValue={[]}
                        mode="multiple"
                        listOptions={STATUS}
                        style={{ width: '100%' }}
                        field="status" label="Trạng thái"
                        placeholder='Chọn trạng thái'
                        allowClear
                        handleChange={onChangeStatus}
                        isMultiple={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default OddBatchFilter